export default __webpack_public_path__ + "static/media/check.61c2516c.svg";